import { extender } from "@shared/backend/class-extender";
import HyperEntity from "@shared/backend/hyper-entity.decorator";
import { REPEAT_TYPES } from "@shared/helpers/constants";
import { JsonField } from "@shared/helpers/custom-fields";
import { Fields, Relations } from "remult";
import { Opportunity } from "../opportunity";
import { RepeatedOpportunityEntityConfig } from "./config";
import { RepeatedOpportunityFilters } from "./filters";
import { RepeatedOpportunityMethods } from "./methods";

@HyperEntity("repeated-opportunity", RepeatedOpportunityEntityConfig)
export class RepeatedOpportunity extends extender(
  RepeatedOpportunityFilters,
  RepeatedOpportunityMethods,
) {
  @Fields.uuid({ allowApiUpdate: false })
  id = "";

  @Relations.toOne<RepeatedOpportunity, Opportunity>(() => Opportunity, {
    fields: {
      repeatedOpportunityId: "id",
    },
  })
  opportunity?: Opportunity;

  @JsonField()
  days: string[] = [];

  @Fields.number()
  interval = 0;

  @Fields.literal(() => REPEAT_TYPES, {
    dbName: "repeat_type",
  })
  repeatType: (typeof REPEAT_TYPES)[number] = "WEEKS";

  @Fields.date({ dbName: "last_date" })
  lastDate = new Date();

  @Fields.createdAt({ dbName: "created_at" })
  createdAt = new Date();

  @Fields.updatedAt({ dbName: "updated_at" })
  updatedAt = new Date();
}
